<template>
  <el-container>
    <el-header>
      <div v-if="!pid">
        <el-select v-model="drumId" placeholder="请选择乐器" clearable @change="selectDrum">
          <el-option v-for="item in searchDrum" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="albumId" placeholder="请选择曲册" clearable @change="selectAlbum">
          <el-option v-for="item in searchAlbum" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select v-model="chapterId" placeholder="请选择章节" clearable @change="selectChapter">
          <el-option v-for="item in searchChapter" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-input class="input-search" v-model="searchParam.title" placeholder="请输入标题">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </div>
      <el-button type="primary" class="primary theme-btn" @click="addContent">新增内容</el-button>
    </el-header>
    <el-main>
      <div class="content-table">
        <el-table :data="contentList">
          <template v-if="!pid">
            <el-table-column label="图片" align="center">
              <template slot-scope="scope">
                <img :src="scope.row.coverUrl" alt="" class="video-img" />
              </template>
            </el-table-column>
            <el-table-column prop="title" label="标题名称" align="center"></el-table-column>
            <el-table-column label="乐器" align="center">
              <template slot-scope="scope">
                <span v-text="resolveData(scope.row.fullCategory, 0)"></span>
              </template>
            </el-table-column>
            <el-table-column label="曲册" align="center">
              <template slot-scope="scope">
                <span v-text="resolveData(scope.row.fullCategory, 1)"></span>
              </template>
            </el-table-column>
            <el-table-column label="章节" align="center">
              <template slot-scope="scope">
                <span v-text="resolveData(scope.row.fullCategory, 2)"></span>
              </template>
            </el-table-column>
            <el-table-column label="是否为考级示范" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.isFree === -1" style="color: red">已禁用</span>
                <span v-else v-text="scope.row.isFree ? '是' : '否'"></span>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column prop="speed" label="曲速" align="center"></el-table-column>
            <el-table-column label="视频" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.videoId">
                  <video-play :keyword="`ali_vid_${scope.row.videoId}`" :video-data="scope.row"></video-play>
                </div>
                <span v-else>未上传视频</span>
              </template>
            </el-table-column>
          </template>
          <!-- 父课程不显示是否上传视频 -->
          <!-- <el-table-column label="是否上传视频" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.videoId">已上传</p>
              <p v-else class="fontRed">未上传</p>
            </template>
          </el-table-column> -->
          <template v-if="pid">
            <el-table-column label="操作" width="320" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  @click="handleEdit(scope.$index, scope.row)"
                  >更新视频
                </el-button>
                <!-- <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="deleteContent(scope.$index, scope.row)"
                  >删除
                </el-button> -->
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column label="操作" width="320" align="center">
              <template slot-scope="scope">
                <!-- <el-button v-if="scope.row.videoId" size="mini" type="primary" plain @click="handleCheck(scope.$index, scope.row)">查看</el-button>
                <el-button
                  v-else
                  size="mini"
                  type="primary"
                  plain
                  @click="handleEdit(scope.$index, scope.row)"
                  >上传视频
                </el-button> -->
                <!--              @click="handleAddVideo(scope.$index, scope.row)">上传视频-->
                <el-button
                  size="mini"
                  type="warning"
                  class="theme-btn"
                  plain
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                </el-button>
                <!-- <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="deleteContent(scope.$index, scope.row)"
                  >删除
                </el-button> -->
                <!-- <el-button
                  size="mini"
                  type="warning"
                  class="theme-btn"
                  plain
                  @click="handleBan(scope.$index, scope.row)"
                  >禁用
                </el-button> -->
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <common-pagination
        @paginationSearch="paginationSearch"
        :pages="pages"
      ></common-pagination>
    </el-main>
  </el-container>
</template>

<script>
import Pagination from "../common/Pagination";
import DialogVideo from "../common/DialogVideo";
import VideoPlay from '@/components/practiceManage/VideoPlay';

export default {
  name: "ContentList",
  props: ["pid"],
  components: {
    commonPagination: Pagination,
    VideoPlay
  },
  data() {
    return {
      // 内容列表
      contentList: [],

      // 查询条件
      searchParam: {
        title: "",
        pageNum: 1,
        pageSize: 10,
        categoryId: -1, //类目，默认-1表示查询全部类目   对应乐器 曲册  章节id
      },
      //   总页数
      pages: 0,

      searchDrum: "",
      searchAlbum: "",
      searchChapter: "",

      drumId: "",
      albumId: "",
      chapterId: "",

      // 上传视频弹框控制
      dialogVideoFlag: false,
      // 选择的内容id
      contentId: null,
    };
  },
  created() {
    //  获取所有课程内容
    this.getContent();

    //  获取类目信息 默认是乐器
    this.getData(0, 0);
  },
  methods: {
    // 获取列表
    getContent() {
      let param = {
        ...this.searchParam,
        parentResourceId: this.pid
      }
      this.$api.get("/content/list.json", param).then(
          (res) => {
            // 成功才会有数据
            this.contentList = res.data.list;
            this.pages = res.data.pages;
          },
          (err) => {
            this.$message.error(err.msg);
          }
        )
        .catch((err) => {
          this.$message.error("请求异常!");
        });
    },

    // 获取类目列表
    getData(id, flag) {
      let params = {
        // 默认pid 为0  获取的是乐器列表  获取曲册信息pid为乐器的id
        keywords: "",
        pid: id,
      };
      //
      // if (flag === 0) {
      //   // 乐器  根据标题搜索乐器类目  其他不变
      //   params.keywords=this.searchParam.title
      // }
      let res = this.$api.get("/category/list.json", params);
      res
        .then(
          (success) => {
            if (success.code === 200) {
              if (flag === 0) {
                // 乐器
                this.searchDrum = success.data.reverse();
              } else if (flag === 1) {
                // 曲册
                this.searchAlbum = success.data;
              } else {
                //章节
                this.searchChapter = success.data;
              }
            }
            // 为数据添加编辑状态
          },
          (error) => {}
        )
        .catch((err) => {
        });
    },

    selectDrum(id) {
      this.albumId = "";
      this.chapterId = "";
      if (id) {
        //  获取响应的曲册类目  以及该乐器的所有章节  清空其他类目
        this.getData(id, 1);
        this.searchParam.categoryId = id;
      } else {
        this.searchParam.categoryId = -1;
      }
      this.getContent();
    },
    selectAlbum(id) {
      this.chapterId = "";
      if (id) {
        //获取该乐器的所有类目 以及该曲册下的所有章节
        this.getData(id, 2);
        this.searchParam.categoryId = id;
      } else {
        // categoryId 为当前乐器id drumId
        this.searchParam.categoryId = this.drumId;
      }
      this.getContent();
    },

    selectChapter(id) {
      //  获取章节信息  若id为空 则 categoryId 为当前曲册id this.albumId
      id
        ? (this.searchParam.categoryId = id)
        : (this.searchParam.categoryId = this.albumId);
      this.getContent();
    },

    // 解析类目
    resolveData(str, flag) {
      let strList = str.split(",");
      if (flag === 0) {
        return strList[0] ? strList[0] : "";
      } else if (flag === 1) {
        return strList ? strList[1] : "";
      } else {
        return strList[2] ? strList[2] : "";
      }
    },

    // 搜索
    searchData() {
      // 每次搜索都显示第一页
      this.searchParam.pageNum = 1;
      this.getContent();
      //   获取乐器；类目
      // this.getData(0, 0)
    },
    // 分页搜索
    paginationSearch(pageNum) {
      this.searchParam.pageNum = pageNum;
      this.getContent();
    },

    //  新增内容
    addContent() {
      this.$emit("showAddContent");
    },

    //  查看详情
    handleCheck(index, row) {
      // this.$message.error(row.id);
      this.$emit("showContentDetail", row);
    },

    //   删除内容
    deleteContent(index, row) {
      let res = this.$api.delete("/content/delete.json", { id: row.id });
      res
        .then(
          (success) => {
            if (success.code === 200) {
              this.$message({
                message: "删除成功!",
                type: "success",
              });
              //  获取新数据
              this.getContent();
            } else {
              this.$message.error("删除失败！");
            }
          },
          (err) => {
            this.$message.error(err.msg);
          }
        )
        .catch((err) => {
          this.$message.error("删除异常！");
        });
    },

    //  编辑
    handleEdit(index, row) {
      this.$emit("showContentEdit", row);
    },
    // 禁用
    handleBan(index, row) {
      const h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('p', null, [
          h('span', null, '确定要'),
          h('span', { style: 'color: red' }, '禁用'),
          h('span', null, '内容 '),
          h('span', { style: 'color: #ff9900' }, row.title),
          h('span', null, ' 吗？'),
        ]),
        showCancelButton: true,
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.$api.post2("/content/disable.json", {id: row.id}).then(() => {
              done();
            });
          } else {
            done();
          }
        }
      }).then(action => {
        this.$message({
          message: "禁用成功!",
          type: "success",
        });
        this.getContent();
      });
    }
  },
  filters: {
    // checkVideoId:function (val) {
    //   val
    // }
  },
};
</script>

<style scoped>
.el-header {
  /*padding-top: 20px;*/
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 0;
  padding-right: 0;
  /*justify-content: center;*/
}

.input-search {
  width: 300px;
}

.el-select {
  width: 150px;
}

.primary {
  margin-left: 15px;
  background-color: #ff8750;
  border: 0;
  box-shadow: none;
}

.content-table {
  /*width: 1100px;*/
  width: 100%;
}

.video-img {
  display: inline-block;
  width: 80px;
  height: 60px;
}
.fontRed {
  color: #f80404;
}
</style>



// WEBPACK FOOTER //
// src/components/practiceManage/ContentList.vue